/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { $xhc } from '../tsServer/plugins';
import $gkc from '../typeScriptServiceClientHost';
import { $$jc } from '../ui/activeJsTsEditorTracker';
import { Lazy } from '../utils/lazy';
import { $Chc } from './commandManager';
import { $hkc } from './configurePlugin';
import { $jkc, $ikc } from './goToProjectConfiguration';
import { $Vjc } from './learnMoreAboutRefactorings';
import { $0ic } from './openJsDocLink';
import { $kkc } from './openTsServerLog';
import { $mkc, $lkc } from './reloadProject';
import { $nkc } from './restartTsServer';
import { $ckc } from './selectTypeScriptVersion';
import { $okc } from './tsserverRequests';

export function $pkc(
	commandManager: $Chc,
	lazyClientHost: Lazy<$gkc>,
	pluginManager: $xhc,
	activeJsTsEditorTracker: $$jc,
): void {
	commandManager.register(new $lkc(lazyClientHost));
	commandManager.register(new $mkc(lazyClientHost));
	commandManager.register(new $ckc(lazyClientHost));
	commandManager.register(new $kkc(lazyClientHost));
	commandManager.register(new $nkc(lazyClientHost));
	commandManager.register(new $ikc(activeJsTsEditorTracker, lazyClientHost));
	commandManager.register(new $jkc(activeJsTsEditorTracker, lazyClientHost));
	commandManager.register(new $hkc(pluginManager));
	commandManager.register(new $Vjc());
	commandManager.register(new $okc(lazyClientHost));
	commandManager.register(new $0ic());
}
